import { render, staticRenderFns } from "./AlertIndicator.vue?vue&type=template&id=2fffb3c6&scoped=true&"
import script from "./AlertIndicator.vue?vue&type=script&lang=js&"
export * from "./AlertIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AlertIndicator.vue?vue&type=style&index=0&id=2fffb3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffb3c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VFlex,VLayout})
